var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.887,
    height: 22.553,
    viewBox: "0 0 17.887 22.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M242.167,271A1.167,1.167,0,0,0,241,272.167V274.5a1.167,1.167,0,1,0,2.333,0v-2.333A1.167,1.167,0,0,0,242.167,271Z",
    transform: "translate(-233.223 -257.779)",
    fill: "#f8333d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M157.72,109.554h-.389v-1.167a7.388,7.388,0,1,0-14.776,0v1.167h-.389A1.167,1.167,0,0,0,141,110.721v11.665a1.167,1.167,0,0,0,1.167,1.167H157.72a1.167,1.167,0,0,0,1.167-1.167V110.721A1.167,1.167,0,0,0,157.72,109.554Zm-12.832-1.167a5.055,5.055,0,1,1,10.11,0v1.167h-10.11Zm11.665,12.832H143.333v-9.332h13.221Z",
    transform: "translate(-141 -101)",
    fill: "#f8333d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.78f0e50301f89cfce3d97d21d083e4e7.svg";
export { ForwardRef as ReactComponent };